import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTASection() {
  return <section className="w-full bg-lime py-16 md:py-20" data-id="element-69">
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center" data-id="element-70">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-6" data-id="element-71">
          <h2 className="font-headline text-4xl md:text-5xl text-charcoal" data-id="element-72">
            Get early access to the first Zesty drop.
          </h2>

          <p className="text-lg text-charcoal" data-id="element-73">
            Join the list for the first 250-pouch Citrus drop.
          </p>

          <div className="pt-4" data-id="element-74">
            <a href="https://forms.gle/TCr9CceLKLVH7UWr6" target="_blank" rel="noopener noreferrer" className="inline-block px-8 py-4 bg-pink text-white font-semibold rounded-full hover:opacity-90 transition-opacity" data-id="element-75">
              JOIN WAITLIST →
            </a>
          </div>

          <p className="text-sm text-charcoal/70 pt-2" data-id="element-76">
            No spam. Just drop updates.
          </p>
        </motion.div>
      </div>
    </section>;
}